import { Link } from "react-router-dom";
import { Button } from "@learn-me/ui";
import { FadeIn } from "@/components/animated";
import { ArrowRight, Target, TrendingUp, Clock, Briefcase } from "lucide-react";

const pillars = [
  {
    icon: Target,
    title: "Aprendizaje con propósito",
    description: "Dirección clara hacia objetivos concretos",
  },
  {
    icon: TrendingUp,
    title: "Ejecución orientada a resultados",
    description: "Transformamos conocimiento en acción",
  },
  {
    icon: Clock,
    title: "Disciplina y mejora continua",
    description: "Optimización constante del tiempo y recursos",
  },
  {
    icon: Briefcase,
    title: "Desarrollo aplicado",
    description: "Enfocado al contexto real de trabajo",
  },
];

export function AboutSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <FadeIn direction="left">
            <div>
              <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-sm font-medium rounded-full mb-4">
                Quiénes somos
              </span>
              <h2 className="font-display text-3xl md:text-4xl font-bold text-secondary-900 mb-6">
                Somos la formación que genera resultados
              </h2>
              <p className="text-secondary-600 text-lg leading-relaxed mb-6">
                En ARCUS Learning impulsamos el crecimiento de personas y
                organizaciones a través de aprendizaje con dirección clara y
                enfoque en resultados. Creemos que el desarrollo real ocurre
                cuando el conocimiento se transforma en acción, disciplina y
                mejora continua.
              </p>
              <p className="text-secondary-600 leading-relaxed mb-8">
                Nuestro enfoque va más allá de la capacitación tradicional.
                Trabajamos con líderes y equipos que entienden que evolucionar
                implica reconocer oportunidades de mejora, optimizar el uso del
                tiempo y ejecutar con claridad y compromiso.
              </p>
              <Link to="/quienes-somos">
                <Button variant="outline" className="group">
                  Conocer más sobre nosotros
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </FadeIn>

          {/* Right: Pillars */}
          <FadeIn direction="right" delay={0.2}>
            <div className="grid sm:grid-cols-2 gap-4">
              {pillars.map((pillar, index) => (
                <div
                  key={index}
                  className="bg-secondary-50 rounded-xl p-5 hover:bg-primary-50 transition-colors group"
                >
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-white shadow-sm text-primary-600 mb-4 group-hover:bg-primary-600 group-hover:text-white transition-colors">
                    <pillar.icon className="h-6 w-6" />
                  </div>
                  <h3 className="font-semibold text-secondary-900 mb-1">
                    {pillar.title}
                  </h3>
                  <p className="text-sm text-secondary-600">
                    {pillar.description}
                  </p>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
